import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import LoadingSpinner from '../../../components/loading-spinner';
import Button from "../../../components/button";
import SelectInput from "../../../components/select";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {ReactComponent as ReactLogo} from '../../../button.svg';
import {get_report_matrix, GET_REPORT_MATRIX, clear_activity} from "../../../redux/activities";
import Footer from "../../../components/footer";

function data_years() {
    const year = new Date().getFullYear();
    let data = [] 
    for (var i = year - 4; i <= year; i++) {
        data.push({'id': i, 'name': i});
    }
    return data;
}

const MatrixItem = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const {id_matriz, nombre} = useParams();

    const _get_all_zones = useSelector((state) => state.zones_module._get_all_zones);
    const _get_report_matrix = useSelector((item) => item.activities_module._get_report_matrix);

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [zones, setZones] = useState([]);
    const [month, setMonth] = useState(0);
    const [year, setYear] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [id_zona, setIdZona] = useState([]);

    useEffect(() => {
        if (_get_all_zones.data.datos) {
            let value = _get_all_zones.data.datos.filter(x => x.activo === true);
            setZones(value);
        }
    }, [_get_all_zones]);

    const years = data_years();

    const filter_month = [
        {name: "Enero", id: 1},
        {name: "Febrero", id: 2},
        {name: "Marzo", id: 3},
        {name: "Abril", id: 4},
        {name: "Mayo", id: 5},
        {name: "Junio", id: 6},
        {name: "Julio", id: 7},
        {name: "Agosto", id: 8},
        {name: "Septiembre", id: 9},
        {name: "Octubre", id: 10},
        {name: "Noviembre", id: 11},
        {name: "Diciembre", id: 12}
    ];


    const filterMonth = (e) => {
        setMonth(e.target.value);
    }

    const filterYear = (e) => {
        setYear(e.target.value);
    }

    useEffect(() => {
        if (_get_report_matrix.status === 200) {
            toast.success(_get_report_matrix.data.mensaje);
            dispatch(clear_activity(GET_REPORT_MATRIX));
            setIsLoading(false);
        } else if (_get_report_matrix.status !== 0) {
            toast.error(_get_report_matrix.message);
            dispatch(clear_activity(GET_REPORT_MATRIX));
            setIsLoading(false);
        }
    }, [_get_report_matrix, dispatch])

    const getMatrix = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (month === 0) {
            toast.error("Debe seleccionar una mes", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (year === 0) {
            toast.error("Debe seleccionar el año", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        let v_month = month.toString()
        if (v_month.length === 1) {
            v_month = '0' + v_month;
        }
        var day = (new Date(year, v_month, 0)).getDate();
        const date_start = year.toString() + '-' + v_month.toString() + '-01';
        const date_end = year.toString() + '-' + v_month.toString() + '-' + day.toString();
        dispatch(get_report_matrix(token, {'id_matriz': id_matriz, 'id_zona': id_zona, 'fecha_inicio': date_start, 'fecha_fin': date_end}));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Matríz de hallazgo"
                            items={[{label: "Consulta de resultados", link: "/matriz"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="d-flex">
                                    <div style={{cursor: 'pointer'}} onClick={() => {
                                        history.push(`/matriz`);
                                    }}>
                                        <ReactLogo width={50} heght={40}/>
                                    </div>
                                    <p className="ml-1" style={{marginTop: 5, fontSize: 18, color: '#727E8C'}}>Consulta de {nombre}</p>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-12">
                                        <div className="border_card row">
                                            <div className="col-md-4 col-sm-6 col-12">
                                                <label>Mes</label>
                                                <SelectInput
                                                    id="month"
                                                    name="filtro"
                                                    options={filter_month}
                                                    onChange={filterMonth}
                                                />
                                            </div>
                                            <div className="col-md-4 col-sm-6 col-12">
                                                <label>Año</label>
                                                <SelectInput
                                                    id="year"
                                                    name="year"
                                                    options={years}
                                                    onChange={filterYear}
                                                />
                                            </div>
                                            <div className="col-md-4 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Zona</label>
                                                    <SelectInput
                                                        label="Zona"
                                                        name="id_zona"
                                                        value={id_zona}
                                                        onChange={(e) => {setIdZona(parseInt(e.target.value))}}
                                                        options={zones ? zones.map((item) => ({
                                                            name: item.nombre,
                                                            id: item.id,
                                                        })) : []}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 text-center mt-1">
                                                <Button type="button" text="Exportar" theme="calendar" onClick={getMatrix}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default MatrixItem;
